import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appThousandSeparator]'
})
export class ThousandSeparatorDirective {

  private regex: RegExp = new RegExp(/^\d+(\.\d{0,2})?$/g);

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    console.log('Input detected:', value);
    // Retirer tous les séparateurs avant d’analyser
    const numericValue = value.replace(/[^0-9.]/g, '');
    if (numericValue === '') {
      this.control.control?.setValue(null, { emitEvent: false });
      return;
    }

    // Convertir en nombre
    const numberValue = parseFloat(numericValue);
    if (!isNaN(numberValue)) {
      // Mettre à jour le FormControl (sans déclencher un nouveau event input)
      this.control.control?.setValue(numberValue, { emitEvent: false });
      // Afficher le formaté
      this.el.nativeElement.value = numberValue.toLocaleString('fr-FR');
    } else {
      this.control.control?.setValue(null, { emitEvent: false });
    }
  }

  @HostListener('blur')
  onBlur() {
    const value = this.control.control?.value;
    if (typeof value === 'number') {
      this.el.nativeElement.value = value.toLocaleString('fr-FR');
    }
  }

  @HostListener('focus')
  onFocus() {
    const value = this.control.control?.value;
    if (typeof value === 'number') {
      // Lorsqu'on focus, on enlève le format pour faciliter l'édition
      this.el.nativeElement.value = value.toString();
    }
  }
}
